import React from 'react';

const Badge = ({ children, variant = 'primary', style = {} }) => {
  const getColors = () => {
    switch (variant) {
      case 'success':
        return {
          bg: 'var(--success-light)',
          text: 'var(--success)',
          border: 'rgba(34, 197, 94, 0.2)'
        };
      case 'error':
      case 'danger':
        return {
          bg: 'var(--error-light)',
          text: 'var(--error)',
          border: 'rgba(239, 68, 68, 0.2)'
        };
      case 'warning':
        return {
          bg: 'var(--warning-light)',
          text: 'var(--warning)',
          border: 'rgba(245, 158, 11, 0.2)'
        };
      case 'info':
        return {
          bg: 'var(--info-light)',
          text: 'var(--info)',
          border: 'rgba(59, 130, 246, 0.2)'
        };
      case 'secondary':
        return {
          bg: 'var(--surface-light)',
          text: 'var(--text-secondary)',
          border: 'var(--border)'
        };
      case 'primary':
      default:
        return {
          bg: 'var(--primary-light)',
          text: 'var(--primary)',
          border: 'rgba(37, 99, 235, 0.2)'
        };
    }
  };

  const colors = getColors();

  const badgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 10px',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: '600',
    backgroundColor: colors.bg,
    color: colors.text,
    border: `1px solid ${colors.border}`,
    whiteSpace: 'nowrap',
    ...style
  };

  return (
    <span style={badgeStyle}>
      {children}
    </span>
  );
};

export default Badge;
